/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UserContext } from '../../../contexts/User';
import PlanSelector from '../../../components/PlanSelector';

function Plans() {
  const { activeWorkspace } = useContext(UserContext);
  const location = useLocation();

  // Check if we're in renewal context
  const searchParams = new URLSearchParams(location.search);
  const isRenewing = searchParams.get('renew') === 'true';

  return (
    <PlanSelector
      activeWorkspace={activeWorkspace}
      context="settings"
      isRenewing={isRenewing}
    />
  );
}

export default Plans;
